import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "platform-logs-page min-h-screen bg-gray-50" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 py-6" }
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = { class: "flex items-center gap-3 mb-2" }
const _hoisted_5 = { class: "w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center shadow-md" }
const _hoisted_6 = {
  key: 0,
  class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6"
}
const _hoisted_7 = { class: "bg-gradient-to-br from-green-500 to-green-600 rounded-xl shadow-lg p-5 text-white transform transition-all hover:scale-105 hover:shadow-xl" }
const _hoisted_8 = { class: "flex items-center justify-between" }
const _hoisted_9 = { class: "text-3xl font-bold" }
const _hoisted_10 = { class: "w-14 h-14 bg-white bg-opacity-20 rounded-full flex items-center justify-center" }
const _hoisted_11 = { class: "mt-3 flex items-center text-green-100 text-xs" }
const _hoisted_12 = { class: "bg-gradient-to-br from-red-500 to-red-600 rounded-xl shadow-lg p-5 text-white transform transition-all hover:scale-105 hover:shadow-xl" }
const _hoisted_13 = { class: "flex items-center justify-between" }
const _hoisted_14 = { class: "text-3xl font-bold" }
const _hoisted_15 = { class: "w-14 h-14 bg-white bg-opacity-20 rounded-full flex items-center justify-center" }
const _hoisted_16 = { class: "mt-3 flex items-center text-red-100 text-xs" }
const _hoisted_17 = { class: "bg-gradient-to-br from-yellow-500 to-orange-500 rounded-xl shadow-lg p-5 text-white transform transition-all hover:scale-105 hover:shadow-xl" }
const _hoisted_18 = { class: "flex items-center justify-between" }
const _hoisted_19 = { class: "text-3xl font-bold" }
const _hoisted_20 = { class: "w-14 h-14 bg-white bg-opacity-20 rounded-full flex items-center justify-center" }
const _hoisted_21 = { class: "mt-3 flex items-center text-yellow-100 text-xs" }
const _hoisted_22 = { class: "bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl shadow-lg p-5 text-white transform transition-all hover:scale-105 hover:shadow-xl" }
const _hoisted_23 = { class: "flex items-center justify-between" }
const _hoisted_24 = { class: "text-3xl font-bold" }
const _hoisted_25 = { class: "w-14 h-14 bg-white bg-opacity-20 rounded-full flex items-center justify-center" }
const _hoisted_26 = { class: "mt-3 flex items-center text-blue-100 text-xs" }
const _hoisted_27 = { class: "bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" }
const _hoisted_28 = {
  key: 2,
  class: "fixed inset-0 bg-black bg-opacity-20 flex items-center justify-center z-50"
}
const _hoisted_29 = { class: "bg-white rounded-lg p-6 shadow-2xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_PlatformLogsFilters = _resolveComponent("PlatformLogsFilters")!
  const _component_PlatformLogsTable = _resolveComponent("PlatformLogsTable")!
  const _component_PlatformLogsPagination = _resolveComponent("PlatformLogsPagination")!
  const _component_PlatformLogDetails = _resolveComponent("PlatformLogDetails")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_icon, {
              color: "white",
              size: "28"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("mdi-file-document-multiple", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", null, [
            _createElementVNode("h1", { class: "text-3xl font-bold text-gray-800" }, "لاگ‌های سیستم"),
            _createElementVNode("p", { class: "text-sm text-gray-500 mt-1" }, " مشاهده و جستجوی پیشرفته لاگ‌های سیستم، کاربران و ادمین‌ها ")
          ], -1))
        ])
      ]),
      (_ctx.stats)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", null, [
                  _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-green-100 text-sm font-medium mb-1" }, "موفق", -1)),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.formatNumber(_ctx.stats.byStatus.SUCCESS || 0)), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_v_icon, {
                    size: "32",
                    color: "white"
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("mdi-check-circle", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_v_icon, {
                  size: "14",
                  color: "white",
                  class: "ml-1"
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode("mdi-trending-up", -1)
                  ]))]),
                  _: 1
                }),
                _cache[5] || (_cache[5] = _createElementVNode("span", null, "عملیات موفق", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", null, [
                  _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-red-100 text-sm font-medium mb-1" }, "ناموفق", -1)),
                  _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.formatNumber(_ctx.stats.byStatus.FAILED || 0)), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_v_icon, {
                    size: "32",
                    color: "white"
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode("mdi-close-circle", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_v_icon, {
                  size: "14",
                  color: "white",
                  class: "ml-1"
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("mdi-alert-circle", -1)
                  ]))]),
                  _: 1
                }),
                _cache[9] || (_cache[9] = _createElementVNode("span", null, "عملیات ناموفق", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", null, [
                  _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-yellow-100 text-sm font-medium mb-1" }, "در انتظار", -1)),
                  _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.formatNumber(_ctx.stats.byStatus.PENDING || 0)), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_v_icon, {
                    size: "32",
                    color: "white"
                  }, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                      _createTextVNode("mdi-clock-outline", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_v_icon, {
                  size: "14",
                  color: "white",
                  class: "ml-1"
                }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode("mdi-timer-sand", -1)
                  ]))]),
                  _: 1
                }),
                _cache[13] || (_cache[13] = _createElementVNode("span", null, "در حال پردازش", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", null, [
                  _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-blue-100 text-sm font-medium mb-1" }, "کل لاگ‌ها", -1)),
                  _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.formatNumber(_ctx.totalItems)), 1)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_v_icon, {
                    size: "32",
                    color: "white"
                  }, {
                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                      _createTextVNode("mdi-database", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_v_icon, {
                  size: "14",
                  color: "white",
                  class: "ml-1"
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode("mdi-file-multiple", -1)
                  ]))]),
                  _: 1
                }),
                _cache[17] || (_cache[17] = _createElementVNode("span", null, "مجموع رکوردها", -1))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_PlatformLogsFilters, {
        filters: _ctx.filters,
        loading: _ctx.loading,
        onApply: _ctx.handleApplyFilters,
        onReset: _ctx.handleResetFilters
      }, null, 8, ["filters", "loading", "onApply", "onReset"]),
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_PlatformLogsTable, {
          logs: _ctx.platformLogs,
          loading: _ctx.loading,
          stats: _ctx.stats,
          onViewDetails: _ctx.handleViewDetails
        }, null, 8, ["logs", "loading", "stats", "onViewDetails"])
      ]),
      (_ctx.totalItems > 0)
        ? (_openBlock(), _createBlock(_component_PlatformLogsPagination, {
            key: 1,
            page: _ctx.pagination.page,
            "page-size": _ctx.pagination.pageSize,
            "total-items": _ctx.totalItems,
            "total-pages": _ctx.totalPages,
            onPageChange: _ctx.handlePageChange,
            onPageSizeChange: _ctx.handlePageSizeChange
          }, null, 8, ["page", "page-size", "total-items", "total-pages", "onPageChange", "onPageSizeChange"]))
        : _createCommentVNode("", true),
      _createVNode(_component_PlatformLogDetails, {
        log: _ctx.selectedLog,
        show: _ctx.showDetailsDialog,
        onClose: _ctx.handleCloseDetails
      }, null, 8, ["log", "show", "onClose"]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "primary",
                size: "48"
              }),
              _cache[18] || (_cache[18] = _createElementVNode("p", { class: "mt-4 text-gray-600 font-medium" }, "در حال بارگذاری...", -1))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}